"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const faArrowUpRightFromSquare_1 = require("@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const translate_1 = require("components/translate");
const NewTabLinkButton = ({ className, label, ...rest }) => {
    const classes = (0, classnames_1.default)('hot-button hot-button--primary _text-decoration-none', className);
    return ((0, jsx_runtime_1.jsxs)("a", { className: classes, target: "_blank", rel: "noreferrer noopener", ...rest, children: [(0, jsx_runtime_1.jsx)(translate_1.I18n, { label: label }), (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faArrowUpRightFromSquare_1.faArrowUpRightFromSquare, className: "_ml-2" })] }));
};
exports.default = NewTabLinkButton;
